// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-wAeN","title":"styles_title__-bji2","body":"styles_body__yGT0J","section":"styles_section__-LhO2"};